import script from "./APIDocs.vue?vue&type=script&setup=true&lang=js"
export * from "./APIDocs.vue?vue&type=script&setup=true&lang=js"

import "./APIDocs.vue?vue&type=style&index=0&id=76bba689&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76bba689"]])

export default __exports__